import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';

export default function Testimonials() {
  const testimonials = [
    {
      name: 'Mohan  Agarwal',
      role: 'Founder',
      company: 'Greenwood High School',
      //image: 'https://images.unssh.com/photo-1494790108377-be9c29b29330?w=200&q=80',
      quote: 'Code Credence transformed our entire digital infrastructure. The portals and student tracking dashboards they engineered handle 2,000+ active users daily. Their clean engineering and support are unparalleled.',
      rating: 5
    },
    {
      name: 'Nitish Singh',
      role: 'CEO',
      company: 'TechFlow Solutions',
      //image: 'https://images.unssh.com/photo-1472099645785-5658abf4ff4e?w=200&q=80',
      quote: 'Working with Code Credence was a game-changer for our cloud SaaS startup. They delivered our complete core product MVP on time. Their system performance optimization boosted our platform speeds by 40%.',
      rating: 5
    },
    {
      name: 'Akhtar Alam',
      role: 'Founder',
      company: '11 Studio',
      //image: 'https://images.unlas.com/photo-1438761681033-6461ffad8d80?w=20&q=80',
      quote: 'The Custom Salon Management system built by Code Credence has completely automated booking workflows. It is beautifully designed, mobile responsive, and has reduced booking admin errors by 90%. Excellent team!',
      rating: 5
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: index * 0.08, ease: 'easeOut' }
    })
  };

  return (
    <section id="testimonials" className="py-24 md:py-32 relative bg-[#F8F5F0]" data-testid="testimonials-section">
      {/* Glow background */}
      <div className="absolute top-1/2 left-1/4 glowing-blob blob-beige opacity-[0.05]" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">

        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-xs font-semibold tracking-widest uppercase text-transparent bg-clip-text bg-gradient-to-r from-[#8B6B4A] to-[#C8A97E] font-poppins mb-3 block" data-testid="testimonials-label">
            Endorsements
          </span>
          <h2 className="text-4xl md:text-5xl font-bold font-space text-[#3E2F24] tracking-tight" data-testid="testimonials-heading">
            What Our Partners Say
          </h2>
          <p className="text-[#6B625B] text-base sm:text-lg font-poppins max-w-2xl mx-auto mt-4">
            We build long-term relationships founded on top-tier engineering standards and absolute reliability.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((test, index) => (
            <motion.div
              key={test.name}
              custom={index}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-50px' }}
              className="relative p-8 rounded-3xl bg-white/40 border border-[#8B6B4A]/10 hover:border-[#8B6B4A]/30 transition-all duration-300 flex flex-col justify-between group shadow-sm backdrop-blur-md"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon Overlay */}
              <div className="absolute top-6 right-8 text-[#8B6B4A]/5 group-hover:text-[#8B6B4A]/10 transition-colors pointer-events-none">
                <Quote className="w-12 h-12" fill="currentColor" />
              </div>

              <div>
                {/* Stars Rating */}
                <div className="flex gap-1 mb-6">
                  {[...Array(test.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#C8A97E] text-[#C8A97E]" />
                  ))}
                </div>

                {/* Quote Text */}
                <p className="text-[#3E2F24] font-poppins text-xs sm:text-sm leading-relaxed mb-8 italic" data-testid={`testimonial-quote-${index}`}>
                  "{test.quote}"
                </p>
              </div>

              {/* Author Info */}
              <div className="flex items-center gap-4 border-t border-[#8B6B4A]/10 pt-6">
                {/* <img
                  src={test.image}
                  alt={test.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-[#8B6B4A]/15 shadow-sm"
                  loading="lazy"
                  data-testid={`testimonial-image-${index}`}
                /> */}
                <div>
                  <h4 className="text-sm font-bold font-space text-[#3E2F24]" data-testid={`testimonial-name-${index}`}>
                    {test.name}
                  </h4>
                  <p className="text-[11px] font-poppins text-[#6B625B] mt-0.5" data-testid={`testimonial-role-${index}`}>
                    {test.role}, <span className="text-[#8B6B4A]">{test.company}</span>
                  </p>
                </div>
              </div>

            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}